import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Form, DatePicker, Button, ConfigProvider, Divider, Row, Col  } from 'antd';
import { Spinner } from 'reactstrap';
import zhCN from 'antd/lib/locale/zh_CN';
import axios from '../../utils/request';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

let applyIds = "";
let applicantIds = [];
let urgedate = "";

export class JiangNanNongShang extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            applyIds: "",
            applicantIds: [],
            urgedate: ""
        }
    };
    formRef = React.createRef()

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        if (!commonParamater) {
            this.setState({ errorMessage: "commonParamater不存在！", isLoading: false, isReady: true });
            return;
        }
        this.loadPage(commonParamater);
    };

    loadPage = (commonParamater) => {
        const params = {
            commonParamater
        }
        axios
            .get("/api/JiangNanNongShang/GetCurrentUrgeDate", { params: params })
            .then(res => {
                const isSuccessValue = res.data.code == "200";
                let resdata = res.data.data;
                let errorMessage = "";
                if (!isSuccessValue) {
                    errorMessage = "获取应聘者停止催办时间失败！" + res.data.message
                } else {
                    if (resdata !== "") {
                        errorMessage = "";
                        applyIds = resdata.applyIds;
                        applicantIds = resdata.applicantIds;
                        urgedate = resdata.urgeDate;

                        this.setState({
                            applyIds: applyIds,
                            applicantIds: applicantIds,
                            urgedate: urgedate
                        })
                    } else {
                        errorMessage = "获取应聘者停止催办时间失败！";
                    }
                }
                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    onFinish = (values) => {
        applyIds = this.state.applyIds;
        applicantIds = this.state.applicantIds;
        urgedate = this.state.urgedate;
        const params = {
            applyIds,
            applicantIds,
            urgedate
        }
        const bodyString = JSON.stringify(params);
        axios
            .post("/api/JiangNanNongShang/UpdateUrge", bodyString,
                {
                    headers: { "Content-Type": "application/json" }
                })
            .then(res => {
                const isSuccessValue = res.data.code == "200";
                const resback = res.data.message;
                let errorMessage = "";
                if (!isSuccessValue) {
                    errorMessage = "提交失败" + resback
                } else {
                    errorMessage = "提交成功"
                }
                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    postSelectedValue = (value) => {
        if (value !== null && value !== "") {
            urgedate = value.format('YYYY-MM-DD');
            this.setState({
                urgedate: urgedate
            })
        }
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
            else {
                return (
                    <ConfigProvider locale={zhCN}>

                        <div style={{ width: "100%", padding: "25px" }}>
                            <Divider orientation="left" style={{ fontSize: "18px" }}>编辑信息</Divider>
                            <Row style={{ marginTop:"15px" }}>
                                <Col span={4}></Col>
                                <Col span={16}>
                                    <Form onFinish={this.onFinish} ref={this.formRef} initialValues={{
                                        selecturgedate: urgedate ? moment(urgedate, 'YYYY-MM-DD') : ""
                                    }}>
                                        <Form.Item
                                            name="selecturgedate"
                                            label="停止催办时间"
                                            required
                                            rules={[
                                                {
                                                    required: true,
                                                    message: '请选择日期',
                                                },
                                            ]}
                                        >
                                            <DatePicker style={{ float: "right" }} onChange={this.postSelectedValue} placeholder="---请选择日期---" format="YYYY-MM-DD"
                                            />

                                        </Form.Item>
                                        <Form.Item>
                                            <Button type="primary" style={{ float: "right" }} htmlType="submit">提交</Button>
                                        </Form.Item>
                                    </Form></Col>
                                <Col span={4}></Col>
                            </Row>
                          
                        </div>
                    </ConfigProvider>
                )
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}